import moment from "moment"; 
import 'moment/locale/vi';

export const ActivityList = ({ activities }) => {
    return (
        <div className="item">
            <span>
                Latest Activities
            </span>

            {activities.length === 0 ? (
                <span 
                    style={{ color: "gray", fontSize: "12px", padding: "10px" }}
                >
                    No recent activity
                </span>
            ) : (
                activities.map((activity) => (
                    <div className="user" key={activity._id}>
                        <div className="userInfo">
                            <img
                                src={
                                activity?.actorId.profilePic?.startsWith("http") 
                                ? activity.actorId.profilePic 
                                : (activity.profilePic || "/public/noAvatar.png")
                                }
                                alt=""
                                onError={(e) => { e.target.src = "/public/noAvatar.png"; }}
                            />

                            <p>
                                <span className="userName">
                                    {activity.actorId?.username || "Hidden user"}
                                </span>
                                
                                <span className="content"> 
                                    {activity.message || "has carried out an activity"}
                                </span>
                            </p>
                        </div>

                        <span className="date">
                            {moment(activity.createdAt).fromNow()}
                        </span>
                    </div>
                ))
            )}
        </div>
    );
};